import { useMemo } from 'react';

import { MenuModulesDesktop } from 'components/header/menu-modules/desktop/MenuModulesDesktop';
import { MenuModulesMobile } from 'components/header/menu-modules/mobile/MenuModulesMobile';
import { buildMenuTree, flattenMenuTree } from 'components/header/menu-modules/utils';
import { usePermissionsContext } from 'context/PermissionsContext';
import { useBreakpoints } from 'hooks/useBreakpoints';
import { router } from 'routes';

/**
 * Componente pai do menu de módulos.
 * Centraliza a construção da árvore de menus e renderiza
 * a variante desktop ou mobile conforme o breakpoint.
 */
export function MenuModules() {
    const { isUpMd } = useBreakpoints();
    const { hasAnyPermission } = usePermissionsContext();

    const menuNodes = useMemo(() => {
        const layoutRoute = router.routes.find((r) => r.path === '/');

        return buildMenuTree(layoutRoute?.children ?? [], '', hasAnyPermission);
    }, [hasAnyPermission]);

    const flatNodes = useMemo(() => flattenMenuTree(menuNodes), [menuNodes]);

    if (isUpMd) return <MenuModulesDesktop menuNodes={menuNodes} flatNodes={flatNodes} />;

    return <MenuModulesMobile menuNodes={menuNodes} flatNodes={flatNodes} />;
}
